import { useState } from "react";
import { Handle, Position } from "reactflow";
import { Radio } from "@material-ui/core";
import { Button, Input, SelectSimple } from "@components/Input";
import { addSvg, copySvg, deleteSvg } from "@assets";
import { PopUp } from "@components/Modals";

import { addArtifact, handleCopy, isSessionParam } from "vendor/application";
import EntityCreateModal from "views/Bots/NLP/application/Build/Tabs/Entities/application/entity_create_modal";
import FloatButtons from "components/Input/float_buttons";
import { useFlowNodes } from "../../../../context";
import { deleteNode } from "../../../utils/deleteNode";
import {UseCustomFields} from "./UseCustomFields";
import { typesNodes } from "../../../../types/nodeTypes/typesNodes";

import "./ParameterConfigIntentNode.scss";

export const ParameterConfigIntentNode = (props) => {
  const { data, id } = props;
  const [open, setOpen] = useState(false);
  const i = data.dataInfo?.indexParam || 0;
  const { 
    intent,
    params,
    updateElement,
    updateParams,
    integrations,
    t,
    setNodes,
    setEdges,
    updateIntent,
    use_custom_fields,
    getCustomFields
  } = useFlowNodes();
 

  const el = intent.parameters[i] || {};

  const updateParam = (e, type, i, bool) => { 
    var value = e?.target?.value ?? e;

    if (type === "entity_type") {
      intent.parameters[i].identification = false;
    }

    if (type === "prompts") {
      intent.parameters[i][type][0] = value;
    } else if (type === "name") {
      if (value.match(/^[a-zA-Z0-9_-]*$/gm)) {
        intent.parameters[i].name = value;
        intent.parameters[i].variable = `$${value}`;
      }
    } else {
      intent.parameters[i][type] = bool ? !intent.parameters[i][type] : value;
    }
    updateIntent(intent);
  };
  const updateArtifacts = (e, i, artifact_type, type) => {
    var res = addArtifact(i, artifact_type, type, intent);
    updateIntent(res);
  };
  

  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="parameter-config-container">
      <div className={"accordion__content"}>
      <div className={"accordion__element_param_content"}>
        <div key={i} className={"accordion__element_param"}>
          <div className={"accordion__element_param_header"}>
            <div className={"accordion__element_param_header_content"}>
              <span>$</span>
              <Input
                type={"transparent"}
                placeholder={t("intents.config.accordion.params.param.name")}
                inputProps={{ "aria-label": "description" }}
                value={el.name}
                onChange={(e) => {
                  updateParam(e, "name", i);
                }}
              />
            </div>
            <div className={"accordion__element_param_header_actions"}>
              <div onClick={() => handleCopy(`${el.variable}`)}>
                {copySvg()}
              </div>
              <div
                onClick={(e) => {
                  updateElement(e, "parameters", "delete", i);
                  setNodes((prevNodes) => {
                    const parametersNodes = prevNodes.filter((node) => node.type === typesNodes.parameterConfig);
                    return prevNodes.map((node) => {
                      if (parametersNodes.includes(node) && node.data?.dataInfo?.indexParam > i) {
                        node.data.dataInfo.indexParam -= 1;
                      }
                      return node;
                    });
                  });
                  deleteNode({ setNodes, setEdges, nodeId: id });
                }}
              >
                {deleteSvg()}
              </div>
            </div>
          </div>
          <div className={"accordion__element_content"}>
            <div
              className={`accordion__params_checkbox ${
                isSessionParam(el.entity_type) ? "identification" : ""
              }`}
            >
              <div className={"actions"}>
                <SelectSimple
                  className={"select_secondary nodrag"}
                  valueSelected={el.entity_type ? el.entity_type : false}
                  items={params}
                  onSelect={(e) => {
                    updateParam(e, "entity_type", i);
                  }}
                  placeholder={t(
                    "intents.config.accordion.params.param.entity"
                  )}
                  type={i}
                  t={t}
                />
                <Button
                  className={"btn_icon"}
                  type={"white"}
                  onClick={() => {
                    setOpen(true);
                  }}
                  text={addSvg()}
                />
              </div>
              {isSessionParam(el.entity_type) && (
                <div className={"checkbox"}>
                  <span>
                    {t("intents.config.accordion.params.param.identification")}
                  </span>
                  <Radio
                    checked={el.identification}
                    onClick={(e) => {
                      updateParam(e, "identification", i, "bool");
                    }}
                    disableRipple
                  />
                </div>
              )}
              <div className={"checkbox"}>
                <span>
                  {t("intents.config.accordion.params.param.required")}{" "}
                </span>
                <Radio
                  checked={el.required}
                  onClick={(e) => {
                    updateParam(e, "required", i, "bool");
                  }}
                  disableRipple
                />
              </div>
            </div>
            <div className={"accordion__params_prompts"}>
              <Input
                id={`params-prompts-${i}`}
                placeholder={t("intents.config.accordion.params.param.prompt")}
                value={el.prompts?.[0] || ""}
                multiline
                inputProps={{ maxLength: 4096 }}
                onChange={(e) => {
                  updateParam(e, "prompts", i);
                }}
              />
              <FloatButtons
                type={"params"}
                addArtifact={updateArtifacts}
                iteration={i}
                buttons_toggle_artifacts={[
                  "file",
                  "img",
                  "link",
                  "button",
                  "carousel",
                  "bubble",
                  "for",
                  "video"
                ]}
              />
            </div>
            {integrations.length > 0 && (
             <UseCustomFields
             t={t}
             integrations={integrations}
             el={el}
             i={i}
             intent={intent}
             use_custom_fields={use_custom_fields}
             getCustomFields={getCustomFields}
             updateIntent={updateIntent}
           />
            )}
          </div>
        </div>
      </div>
      </div>
      </div>

      <PopUp
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        t={t}
        width={"auto"}
        content={<EntityCreateModal type={"content"} />}
        buttons={
          <EntityCreateModal
            type={"button"}
            updateParams={updateParams}
            close={() => setOpen(false)}
          />
        }
      />
    </>
  );
};
